import React from 'react';

export default function Button({ variant = 'primary', size = 'md', className = '', ...props }) {
  return (
    <button
      className={`btn btn-${variant} btn-${size} ${className}`}
      type={props.type || 'button'}
      {...props}
    />
  );
}
